/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_NavInputs */

const en_svc_research_nav = /** @type {(inputs: Svc_Research_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI research agents`)
};

const lv_svc_research_nav = /** @type {(inputs: Svc_Research_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI izpētes aģenti`)
};

/**
* | output |
* | --- |
* | "AI research agents" |
*
* @param {Svc_Research_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_nav = /** @type {((inputs?: Svc_Research_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_nav(inputs)
	return en_svc_research_nav(inputs)
});